import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { http } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { t } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { ApplyDialog, CompanySheet } from "@/components/CompanyBits";
import { toast } from "sonner";

export default function Favorites() {
  const { user, lang, loading } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [apply, setApply] = useState(false);

  const load = () => http.get("/favorites").then((r) => setItems(r.data));

  useEffect(() => {
    if (loading) return;
    if (!user) { nav("/login"); return; }
    load();
  }, [user, nav, loading]);

  const remove = async (id) => {
    await http.delete(`/favorites/${id}`);
    toast.success(t(lang, "remove_favorite"));
    load();
  };

  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-6 py-10">
        <h1 className="font-display text-3xl font-bold tracking-tight text-[#1E3A8A]">{t(lang, "nav_favorites")}</h1>
        <p className="text-slate-500 text-sm mt-1">{items.length}</p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
          {items.map((c) => (
            <div key={c.id} data-testid={`fav-card-${c.id}`} className="rounded-2xl bg-white border border-slate-200 p-5 fade-up">
              <p className="font-display font-semibold text-lg">{c.name}</p>
              <p className="text-xs text-slate-500">{c.city}, {c.country}</p>
              <p className="text-sm text-slate-600 mt-2 line-clamp-2">{c.description}</p>
              <div className="mt-4 flex gap-2">
                <Button size="sm" onClick={() => setSelected(c)} className="bg-[#1E3A8A] hover:bg-[#172554] rounded-full">{lang === "fr" ? "Voir" : "View"}</Button>
                <Button size="sm" variant="outline" onClick={() => remove(c.id)} className="rounded-full"><Heart className="w-3.5 h-3.5 mr-1" /> {t(lang, "remove_favorite")}</Button>
              </div>
            </div>
          ))}
          {items.length === 0 && (
            <div className="col-span-full text-center py-16 border-2 border-dashed border-slate-200 rounded-2xl text-sm text-slate-500">
              <Heart className="w-8 h-8 mx-auto text-slate-300 mb-2" />—
            </div>
          )}
        </div>
      </div>
      {selected && <CompanySheet company={selected} onClose={() => setSelected(null)} onApply={() => setApply(true)} />}
      <ApplyDialog open={apply} onOpenChange={setApply} company={selected} />
    </Layout>
  );
}
